









export default {
  props: ["classpPrefix"],
  name: "Layout",
};
